import React from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";

import { ReactComponent as Logo } from "../../../../assets/svg/logo.svg";
import { loginPath } from "../../../../teacherStore";
import styles from "../Login.module.scss";

const ResetPasswordCompleted: React.FC = () => {
  return (
    <div className={styles.wrapper}>
      <Logo className={styles.logo} />
      <div className={styles.content}>
        <p className={clsx(styles.text, styles.bold)}>
          入力したメールアドレスに新しいパスワード設定のURLを送信しました。
          <br />
          メール受信を確認後、下記の操作を行なってください。
        </p>
        <ul className={styles.list}>
          <li>新しく届いたメールのパスワード設定のURLにアクセス</li>
          <li>新しいパスワードの設定</li>
          <li>パスワード設定後、ログインができるか確認</li>
        </ul>
        <p className={styles.note}>
          ※URLの有効期限は2週間です。
          <br />
          期限が過ぎた場合は、パスワードリセットをやり直してください。
        </p>
        <p className={styles.textCenter}>
          <Link className={styles.link} to={loginPath}>
            ログイン画面に戻る
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ResetPasswordCompleted;
